import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgMissedCall = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "none", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m17.09 13.371 1.143 1.144a1.56 1.56 0 0 1 .41 1.852c-.095.207-.472.625-.646.771-3.118 3.122-6.774 1.706-9.905-1.425s-4.543-6.79-1.41-9.901c.626-.62 1.713-1.142 2.618-.237l1.19 1.192c1.192 1.192.357 1.936-.492 2.804-.925.925-.656 1.728 0 2.384l1.871 1.873a1.684 1.684 0 0 0 2.382 0c.863-.827 1.696-1.6 2.839-.457M14.874 8.98l2.135-2.135m0 0 2.16-1.907m-2.16 1.907 2.16 2.15m-2.16-2.15-2.135-1.907"
  }
) }));

export { SvgMissedCall as default };
//# sourceMappingURL=missed-call.mjs.map
